import React from "react";
import { useNavigate } from "react-router-dom";
import KanbanBoard from "../../components/common/KanbanBoard";

const VendorKanbanView = ({ vendors = [], onEdit, canManage }) => {
  const navigate = useNavigate();

  const COLUMNS = [
    { id: "Active", title: "Active", dotColor: "bg-emerald-500" },
    { id: "Pending", title: "Pending", dotColor: "bg-blue-500" },
    { id: "Inactive", title: "Inactive", dotColor: "bg-gray-400" },
    { id: "Blacklisted", title: "Blacklisted", dotColor: "bg-red-500" }
  ];

  const handleDragEnd = (result) => {
    const { destination, draggableId } = result;
    if (!destination || !canManage) return;
    
    // (Call your context/api update function here if needed to save vendor status)
    console.log(`Update Vendor ${draggableId} to status: ${destination.droppableId}`);
  };

  const renderCard = (vendor) => (
    <div 
      onClick={() => { if(canManage && onEdit) onEdit(vendor.id) }}
      className="bg-white dark:bg-[#161b22] p-4 rounded-xl shadow-xs border border-gray-200 dark:border-[#30363d] hover:shadow-md dark:hover:border-slate-600 transition cursor-grab active:cursor-grabbing flex flex-col min-h-[130px]"
    >
      <div className="flex justify-between items-start gap-2">
        <div className="overflow-hidden">
          <h4 className="font-bold text-gray-900 dark:text-white text-base leading-tight truncate">{vendor.vendorName}</h4>
          <p className="text-[11px] text-gray-500 dark:text-slate-400 font-mono mt-1">ID: {vendor.id}</p>
        </div>
        <span className="text-[10px] bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-slate-300 px-2 py-1 rounded font-bold uppercase tracking-wider border border-gray-200 dark:border-slate-700 shrink-0">
          {vendor.category || 'General'}
        </span>
      </div>

      <div className="mt-auto pt-3 border-t border-gray-100 dark:border-[#30363d] grid grid-cols-2 gap-3">
        <div className="overflow-hidden">
          <span className="block text-[10px] text-gray-400 dark:text-slate-500 font-bold uppercase tracking-wider mb-0.5">Contact</span>
          <span className="text-[11px] font-medium text-gray-600 dark:text-slate-300 truncate block">{vendor.contactEmail || vendor.contactPhone || "—"}</span>
        </div>
      </div>
    </div>
  );

  return (
    <KanbanBoard 
      columns={COLUMNS}
      items={vendors}
      groupBy="vendorStatus" // Assumes the vendor object uses vendorStatus or similar
      onDragEnd={handleDragEnd}
      renderCard={renderCard}
    />
  );
};

export default VendorKanbanView;